module.exports = "/assets/QA_V1-cdcaa8b4c8b741cec6669173f1db0d10.jpg";